<template>
  <div>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FF6907" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-layout wrap justify-start pa-5>
          <v-flex xs12>
            <span class="heading">AI Images</span>
          </v-flex>
          <v-flex xs12>
            <v-layout wrap justify-start pt-2>
              <!-- <v-flex xs12 sm6 md6 lg6 class="subheading">
                <span>Rows per page</span>
                <v-select
                  v-model="count"
                  color="#FF6907"
                  outlined
                  dense
                  hide-details
                  :items="[20, 30, 50]"
                ></v-select>
              </v-flex> -->
              <!-- <v-flex xs12 sm3 md3 lg3>
                <span class="subheading">Filter</span>
                <v-text-field
                  outlined
                  hide-details
                  dense
                  placeholder="Type To Search"
                  v-model="keyword"
                >
                </v-text-field>
              </v-flex> -->
            </v-layout>
           
<v-container fluid class="pa-0">
  <v-row justify-between>
    <v-col
      v-for="(item, index) in allPhotos"
      :key="index"
      cols="12"
      sm="4"
      md="4"
      lg="3"
      v-viewer="{ movable: false }"
      style="cursor: pointer;"
    >

    <div class="relative rounded-lg overflow-hidden elevation-2">

      <v-img
        :src="item.url"
        alt="Snake Image"
        height="200"
        aspect-ratio="1"
        class="rounded-lg elevation-2 clickable"
        cover
        @click="viewImage(item.url)"
      >
    <v-checkbox
            v-model="item.isMLRequired"
            :input-value="item.selected"
            @change="toggleSelection(item, $event)"
            class="image-checkbox pa-0 ma-0"
            hide-details

            color="primary"
          ></v-checkbox>
    </v-img>
    
    </div>
    </v-col>
  </v-row>
</v-container>




<!--Cards-->


          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 pb-4 v-if="allPhotos && allPhotos.length > 0">
        <v-layout wrap justify-center>
          <v-flex xs10>
            <v-pagination
              v-model="currentPage"
              :length="Pagelength"
              :total-visible="7"
              circle
              color="#FF6907"
              small
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 v-else>
        <v-layout wrap justify-center pl-5>
          <v-flex xs12 class="text-center">
            <span class="heading">No Data Found!</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog v-model="confirmDeleteDialog" max-width="500px">
      <v-card>
        <v-card-title class="itemHeading">Confirm Delete</v-card-title>
        <v-card-text>Are you sure you want to delete this user?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            tile
            outlined
            color="#FF1313"
            light
            :ripple="false"
            depressed
            @click="confirmDeleteDialog = false"
            class="itemValue"
          >
            Cancel
          </v-btn>
          <v-btn
            tile
            :color="appColor"
            light
            :ripple="false"
            depressed
            @click="deleteUser"
            class="itemValue"
          >
            <span style="color: #fff">Delete</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-dialog v-model="viewImageDialog" max-width="800px">
  <v-card class="overflow-hidden">
    <v-img
      :src="selectedUrl"
      alt="Preview Image"
      max-height="80vh"
      contain
      class="rounded"
    ></v-img>
  </v-card>
</v-dialog> -->

<v-dialog v-model="viewImageDialog" max-width="700px">
  <v-card class="overflow-hidden relative">
    <!-- Image Preview -->
    <v-img
      :src="selectedUrl"
      alt="Preview Image"
      max-height="80vh"
      contain
      class="rounded"
    ></v-img>

    <!-- Download Button -->
    <v-card-actions class="justify-end px-4 pb-3">

      <v-btn
        color="red"
        @click="viewImageDialog = false"
        class="text-white"
        medium
      >
        <v-icon style="color: white;" left>mdi-close</v-icon>
        <span style="color: white;">Cancel</span>
      </v-btn>

      <v-btn
        color="primary"
        @click="downloadImage"
        class="text-white"
        medium
      >
        <v-icon left>mdi-download</v-icon>
        Download
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

  </div>
</template>
  <script>
import axios from "axios";
export default {
  data() {
    const pageKey = this.$route.name || 'defaultPage';
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      snakeId: this.$route.params.id,
      count: 20,
      keyword: "",
      pageKey,
      currentPage: parseInt(localStorage.getItem(`${pageKey}_currentPage`)) || 1,
      Pagelength: 0,
      allPhotos: [],
      confirmDeleteDialog: false,
      images: [
        '/images/'
      ],
      viewImageDialog: false,
    };
  },
  beforeMount() {
    this.getData();
  },
  watch: {
    currentPage(newVal) {
      localStorage.setItem(`${this.pageKey}_currentPage`, newVal);
      this.getData();
    },
    count() {
      this.getData();
    },
    keyword() {
      this.currentPage = 1;
      this.getData();
    },
  },
  methods: {

    async downloadImage() {
    try {
      const response = await fetch(this.selectedUrl, { mode: 'cors' });
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      // Optional: Extract file name
      const filename = this.selectedUrl.split('/').pop() || 'image.jpg';
      link.download = filename;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Image download failed:', error);
    }
  },
  
    openDeleteDialog(item) {
      this.deleteUserItem = item;
      this.confirmDeleteDialog = true;
    },
    deleteUser() {
      this.appLoading = true;
      axios({
        method: "DELETE",
        url: "/user/delete",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.deleteUserItem._id,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.msg = "User deleted successfully.";
            this.showSnackBar = true;
            this.appLoading = false;
            this.confirmDeleteDialog = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    openEditDialog(item) {
      this.$router.push({
        path: "/edituser",
        query: {
          id: item._id,
        },
      });
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/snake/images-by-id",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          snake_id: this.snakeId,
          page: this.currentPage,
        //   keyword: this.keyword,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.allPhotos = response.data.images;

              this.Pagelength = response.data.totalPages;
              // this.msg = response.data.msg;
              // this.showSnackBar = true;
              this.appLoading = false;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
    viewImage(url) {
      this.selectedUrl = url;
      this.viewImageDialog = true;
    },
    toggleSelection(item, isChecked) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/snake/toggle/ml-required",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          snakeId: this.snakeId,
          imageUrl: item.url,
          isMLRequired : isChecked,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.msg = response.data.msg;
              this.showSnackBar = true;
              this.appLoading = false;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
  },
};
</script>
  <style>
.heading {
  font-family: poppinsregular;
  font-size: 20px;
  font-weight: 900;
}
.subheading {
  font-family: poppinsregular;
  font-size: 15px;
  font-weight: 500;
}
.tableheading {
  font-family: poppinsregular;
  font-size: 15px !important;
  color: black !important;
  text-transform: uppercase !important;
}
.tablesubheading {
  font-family: poppinsregular;
  font-size: 10px;
}
</style>

<style scoped>
.relative {
  position: relative;
}
.image-checkbox {
  position: absolute;
  top: 10px;
  right: 4px;
  z-index: 1;
  border-radius: 4px;
}
</style>